<template>
  <b-modal
    :id="$attrs.id || 'action-modal'"
    :title="title"
    :hide-header-close="true"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    :ok-disabled="isOkDisabled"
    :busy="loading"
    size="lg"
    centered
    @ok="onConfirm"
  >
    <b-form-group>
      <template v-if="reasons.length > 0">
        <div v-for="reason in reasons" :key="reason.id" class="form-check">
          <label class="form-check-label">
            <input
              :value="reason"
              v-model="selectedReason"
              type="radio"
              class="form-check-input"
            />
            {{ reason.name }}
          </label>

          <p
            v-if="reason.note"
            v-show="selectedReason === reason"
            v-html="reason.note"
          />

          <b-textarea
            v-if="reason.hasUserComment && selectedReason === reason"
            :readonly="loading"
            v-model="comment"
          />
        </div>
      </template>
      <b-textarea
        v-else-if="customReason"
        :readonly="loading"
        v-model="selectedReason"
        :placeholder="$t('bookings.reason')"
      />
    </b-form-group>
  </b-modal>
</template>

<script>
export default {
  name: 'ActionModal',
  props: {
    customReason: {
      default: false,
      type: Boolean,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    reasons: {
      type: Array,
      default() {
        return []
      },
    },
    title: {
      required: true,
      type: String,
    },
  },

  data() {
    return {
      comment: null,
      selectedReason: null,
    }
  },

  computed: {
    isOkDisabled() {
      return (
        !this.selectedReason ||
        (this.selectedReason.hasUserComment && !this.comment)
      )
    },
  },

  methods: {
    onConfirm(ev) {
      ev.preventDefault()
      this.$emit('confirm', {
        reason: this.customReason
          ? this.selectedReason
          : this.selectedReason.id,
        comment: this.selectedReason.hasUserComment ? this.comment : null,
      })
    },
  },
}
</script>
